/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-11-27 09:32:42
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-07-03 15:23:46
 * @FilePath: \vue-hepha-order\src\views\dealer\queryConfig\DealerListQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const PrepaidOrderQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            // name:'order.orderName', // 订单名称
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderName',
        },
        {
            // name:'order.deliveryNumber', // 出库单号
            key:'delivery_number',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'stock.deliveryNumber',
        },
        {
            // name:'order.orderSource', // 订单来源
            key:'source',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.orderSource',
            // optionToLocale:true,
            options:[]
        },
        {
            // name:'order.orderStatus', // 订单状态
            key:'order_status',
            type:'select',   
            allowClear:true,
            width:'170px',
            placeholder:'order.orderStatus',
            optionToLocale:true,
            options:[
                {
                    value:7,
                    label:'order.obligation'
                },
                {
                    value:0,
                    label:'order.partialPay'
                },
                {
                    value:1,
                    label:'order.pay'
                },
                {
                    value:2,
                    label:'order.refund'
                },
                // {
                //     value:3,
                //     label:'order.returnsAndRefund'
                // },
                {
                    value:4,
                    label:'order.partialRefund'
                },
                // {
                //     value:5,
                //     label:'order.partialReturnsAndRefund'
                // },
                // {
                //     value:-1,
                //     label:'order.finalPayment'
                // },
                {
                    value:6,
                    label:'order.canceled'
                },
            ]
        },
        {
            // name:'prepaidOrder.validityStatus', // 是否有效
            key:'validity_status',
            type:'select',   
            allowClear:true,
            width:'130px',
            placeholder:'prepaidOrder.validityStatus',
            optionToLocale:true,
            options:[
                {
                    value:1,
                    label:'prepaidOrder.valid',
                    disabled:false
                },
                {
                    value:2,
                    label:'prepaidOrder.invalid',
                    disabled:false
                },
            ]
        },
        {
            // name:'order.customerName', // SO
            key:'erp_no',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'order.erpNo',
        },
        // {
        //     // name:'order.customerName', // 客户名称
        //     key:'customer_id',
        //     type:'select',   
        //     allowClear:true,
        //     width:'200px',
        //     placeholder:'order.customerName',
        //     options:[]
        // },
        {
            // name:'order.country', // 国家
            key:'country',
            type:'select',   
            allowClear:true,
            width:'200px',
            placeholder:'order.country',
            options:[]
        },
        {
            // name:'order.customerType', // 邮箱
            key:'customer_email',
            type:'input',   
            allowClear:true,
            width:'200px',
            placeholder:'customer.customerEmail',
        },
        {
            // name:'order.orderDate', // 订单时间
            key:'order_date',
            type:'dateRange',   
            allowClear:true,
            // valueFormat:'timestamp',
            width:'230px',
        },
    ]
}

// 发货申请
const DeliverForm = {
    // layout:'inline',
    labelColProps: { span: 8 },
    wrapperColProps: { span: 14 },
    labelAlign:'right',
    labelColStyle:'110px',
    formData:{},
    formField:[
        {
            name:'order.courierType',// 物流公司
            key:'courier_type',
            type:'select',
            allowClear:true,
            required: false,
            width:'450px',
            placeholder:'base.select',
            options:[]
        },
        {
            name:'order.courierNo',//物流单号
            key:'courier_no',
            type:'input',   
            allowClear:true,
            required: false,
            disabled:false,
            width:'450px',
            placeholder:'base.input',
        },
        {
            name:'order.courierLink',//物流链接
            key:'courier_url',
            type:'input',   
            allowClear:true,
            required: false,
            disabled:false,
            width:'450px',
            placeholder:'base.input',
        },
        {
            name:'order.handleTimestamp',//预计发货时间
            key:'transaction_date',
            type:'date',
            required: false,
            width:'450px',
            disabledDate:true,
        },
    ]
}

PrepaidOrderQuery.formField.forEach(item=>{
    PrepaidOrderQuery.formData[item.key] = ''
})

DeliverForm.formField.forEach(item=>{
    DeliverForm.formData[item.key] = ''
})

export {
    PrepaidOrderQuery,
    DeliverForm
}